import "./AboutOurTeamSection.scss";
import FS_ABOUT_EQUIPO_IMAGEN from "../../../assets/img/FS-ABOUT-EQUIPO-IMAGEN.png";
import TeamBlockContent from "../../Molecules/TeamBlocksContent/TeamBlockContent";
import FS_ABOUT_EQUIPO_HELPDESK_ICON from "../../../assets/img/FS-ABOUT-EQUIPO-HELPDESK-ICON.svg";
import FS_ABOUT_EQUIPO_DESARROLLO_ICON from "../../../assets/img/FS-ABOUT-EQUIPO-DESARROLLO-ICON.png"
import FS_ABOUT_EQUIPO_INFRAESTRUCTURA_ICON from "../../../assets/img/FS-ABOUT-EQUIPO-INFRAESTRUCTURA-ICON.png"
import FS_ABOUT_EQUIPO_PRODUCTO_ICON from "../../../assets/img/FS-ABOUT-EQUIPO-PRODUCTO-ICON.svg";
import FS_ABOUT_EQUIPO_calidad_ICON from "../../../assets/img/FS-ABOUT-EQUIPO-calidad-ICON.png"
import FS_ABOUT_EQUIPO_INGENIERIA_ICON from "../../../assets/img/FS-ABOUT-EQUIPO-INGENIERIA-ICON.png";
import content from "../../Pages/About/content"
import { useLanguageCtx } from "../../../store/providers/LanguageContext";

const AboutOurTeamSection = () => {
	const {language} = useLanguageCtx();

  return (
		<div className="aboutOurTeamSection-container max-width top-space-section about">
			<div className="aboutOurTeamSection-left-container grid fullColumn">
				<div className="aboutOurTeamSection-team-image-container">
					<img
						src={FS_ABOUT_EQUIPO_IMAGEN}
						alt="Team"
						className="all-width-height aspect-ratio contain aboutOurTeamSection-team-image"
					/>
				</div>
				<div className="aboutOurTeamSection-header-container">
					<h5 className="t5 c-yellow no-space yellow-line right-side">
						{content[language].nuestroEquipoYellowTitle}
					</h5>
					<h3 className="t3">{content[language].nuestroEquipoBoldText}</h3>
				</div>
			</div>
			<div className="aboutOurTeamSection-right-container grid fullColumn">
				<div className="aboutOurTeamSection-block-1">
					<TeamBlockContent
						title={content[language].servicioTitle}
						content={content[language].servicioContent}
						icon={FS_ABOUT_EQUIPO_HELPDESK_ICON}
					/>
				</div>
				<div className="aboutOurTeamSection-block-2">
					<TeamBlockContent
						title={content[language].desarrolloTitle}
						content={content[language].desarrolloContent}
						icon={FS_ABOUT_EQUIPO_DESARROLLO_ICON}
					/>
				</div>
				<div className="aboutOurTeamSection-block-3">
					<TeamBlockContent
						title={content[language].infraestructuraTitle}
						content={content[language].infraestructuraContent}
						icon={FS_ABOUT_EQUIPO_INFRAESTRUCTURA_ICON}
					/>
				</div>
				<div className="aboutOurTeamSection-block-4">
					<TeamBlockContent
						title={content[language].productoTitle}
						content={content[language].productoContent}
						icon={FS_ABOUT_EQUIPO_PRODUCTO_ICON}
					/>
				</div>
				<div className="aboutOurTeamSection-block-5">
					<TeamBlockContent
						title={content[language].calidadTitle}
						content={content[language].calidadContent}
						icon={FS_ABOUT_EQUIPO_calidad_ICON}
					/>
				</div>
				<div className="aboutOurTeamSection-block-6">
					<TeamBlockContent
						title={content[language].ingenieriaTitle}
						content={content[language].ingenieriaContent}
						icon={FS_ABOUT_EQUIPO_INGENIERIA_ICON}
					/>
				</div>
			</div>
		</div>
	);
};

export default AboutOurTeamSection;
